import { render, staticRenderFns } from "./PatientCompose.vue?vue&type=template&id=059d8afd&scoped=true"
import script from "./PatientCompose.vue?vue&type=script&lang=js"
export * from "./PatientCompose.vue?vue&type=script&lang=js"
import style0 from "./PatientCompose.vue?vue&type=style&index=0&id=059d8afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d8afd",
  null
  
)

export default component.exports